import moment from "moment-timezone";
import { getStoreURL } from "@/util.js";

const convenienceStore = (store) => ({
  "@context": "https://schema.org",
  "@type": "ConvenienceStore",
  address: {
    "@type": "PostalAddress",
    addressCountry: store.country,
    addressLocality: store.city,
    addressRegion: store.state,
    postalCode: store.zip,
    streetAddress: store.singleline,
  },
  areaServed: {
    "@type": "GeoCircle",
    geoMidpoint: {
      "@type": "GeoCoordinates",
      latitude: store.lat,
      longitude: store.lng,
    },
    geoRadius: 3218,
  },
  description: store.blurb,
  hasMap: {
    "@type": "Map",
    url: `${getStoreURL()}/about`,
  },
  hasPOS: {
    "@type": "Place",
    address: {
      "@type": "PostalAddress",
      addressCountry: "USA",
      addressLocality: "Newark",
      addressRegion: "NJ",
      postalCode: "07102",
      streetAddress: "520 Broad Street",
    },
    description: "The All-in-one Point Of Sale System For Your Retail Business",
    email: "info@nrsplus.com",
    image:
      "https://nrsplus.com/wp-content/uploads/2022/01/pos-mobile-small-min.png",
    keywords: "POS",
    logo: "https://nrsplus.com/nrsnew/images/nrs-logo-small.png",
    name: "National Retail Solutions",
    telephone: "+18002150931",
    url: "https://nrsplus.com/",
  },
  image: store.image,
  keywords: "Convenience Store, Pickup, Delivery, Online",
  latitude: store.lat,
  longitude: store.lng,
  name: store.name,
  openingHours: formatOpeningHours(store.store_info.hoursLtIso),
  publicAccess: true,
  ...(someSocialMediaLinks(store.store_info.social_media) && {
    sameAs: getSocialMediaLinks(store.store_info.social_media),
  }),
  telephone: store.phone,
  url: getStoreURL(),
});

/*
const product = () => ({
  "@context": "https://schema.org",
  "@type": "Product",
});

const offerShippingDetails = () => ({
  "@context": "https://schema.org",
  "@type": "OfferShippingDetails",
  deliveryTime: {
    "@type": "ShippingDeliveryTime",
    businessDays: {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: [
        "https://schema.org/Monday",
        "https://schema.org/Tuesday",
        "https://schema.org/Wednesday",
        "https://schema.org/Thursday",
        "https://schema.org/Friday",
      ],
    },
    cutoffTime: "12:00:15Z",
    handlingTime: {
      "@type": "QuantitativeValue",
      minValue: 1,
      maxValue: 2,
      unitCode: "d",
    },
    transitTime: {
      "@type": "QuantitativeValue",
      minValue: 1,
      maxValue: 10,
      unitCode: "d",
    },
  },
  shippingRate: {
    "@type": "MonetaryAmount",
    value: 4.95,
    currency: "USD",
  },
});
*/

const formatOpeningHours = (hours) => {
  let openingHours = [];

  const formatDay = (day) => {
    return day.slice(0, -1);
  };

  const formatTime = (time) => {
    return moment(time).format("HH:mm");
  };

  for (const [key, value] of Object.entries(hours)) {
    openingHours.push(
      `${formatDay(key)} ${formatTime(value[0][0])}-${formatTime(value[0][1])}`
    );
  }

  return openingHours;
};

const getSocialMediaLinks = (platforms) => {
  return platforms
    .filter((platform) => platform.url)
    .map((platform) => platform.url);
  // return platforms.map((platform) => platform.url)
};

const someSocialMediaLinks = (platforms) => {
  return platforms?.some((platform) => platform.url);
  // return platforms.map((platform) => platform.url)
};

const map = {
  convenienceStore,
  //  product,
};

export const setJsonLd = (type, data) => {
  const structuredDataText = map[type](data);
  setJsonLdScript(structuredDataText);
};

const setJsonLdScript = (structuredDataText) => {
  const script = document.createElement("script");
  script.setAttribute("type", "application/ld+json");
  script.textContent = JSON.stringify(structuredDataText, null, 2);
  document.head.appendChild(script);
};
